import { TrackTypeEnum } from '@/entities/tracks'
import { type TrackModel, type UpdateTrackModel } from '@/shared/api'

import type { TrackFormModel } from '..'

export function getTrackRequestByFormValues(
  values: TrackFormModel,
  trackData: TrackModel | null,
): UpdateTrackModel {
  return {
    name: values.name,
    type: values.type,
    authorId: values.authorId,
    coauthorIds: values.coauthorIds ?? null,
    genreIds: values.type === TrackTypeEnum.Sermon ? null : values.genreIds,
    moodIds: values.type === TrackTypeEnum.Sermon ? null : values.moodIds,
    albumId: values.albumId,
    pictureFileId:
      values.pictureFile && !values.useAlbumPicture
        ? values.pictureFile.id
        : null,
    useAlbumPicture: values.useAlbumPicture,
    fileIds:
      values.trackFile && values.trackFile.id ? [values.trackFile.id] : [],
    releaseDate: trackData?.album?.releaseDate ?? null,
  }
}
